export default __webpack_public_path__ + "static/character_6-1de98fdbee2b1a04bc4e58473a07212a.png";